import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import InvoicePreviewLayer from "../components/InvoicePreviewLayer";




const InvoicePreviewPage = () => {
  return (
    <>


      {/* Breadcrumb */}
      <Breadcrumb title="Invoice - Preview" />

      {/* InvoicePreviewLayer */}
      <InvoicePreviewLayer />


    </>
  );
};

export default InvoicePreviewPage;
